<div class="flex flex-col space-y-1">
    <span class="flex items-center gap-1 status">
        <span class="h-3 w-3 rounded-full bg-success-600" aria-hidden="true">
        </span>
        <span>As Requested</span>
    </span>

    <span class="flex items-center gap-1 status">
        <span class="h-3 w-3 rounded-full bg-secondary-300" aria-hidden="true">
        </span>
        <span>Available Candidates</span>
    </span>
</div>
